module.exports = __webpack_public_path__ + "static/media/King.7a2a6a62.png";